import { keyMirror } from "../../../utils";

const constants = keyMirror(['ON_TABLE_SORT', 'ON_TABLE_PAGE_CHANGE', 'ON_TABLE_ROWS_ON_PAGE_CHANGE']);

export const onTableSort = (tableName: string, headerId: string) => ({
  type: constants.ON_TABLE_SORT,
  payload: { tableName, headerId },
});

export const onPageChange = (tableName: string, current: number) => ({
  type: constants.ON_TABLE_PAGE_CHANGE,
  payload: { tableName, current },
});

export const onRowsOnPageChange = (tableName: string, pageSize: number) => ({
  type: constants.ON_TABLE_ROWS_ON_PAGE_CHANGE,
  payload: { tableName, pageSize },
});
